module.exports = __webpack_public_path__ + "img/46.96128b0e.png";